export default {
  common: {
    home: 'Home',
    about: 'About Us',
    services: 'Product Services',
    contact: 'Contact Us',
    company: 'Company Introduction',
    technical: 'Technical Services'
  },
  header: {
    navigation: 'Navigation Menu',
    language: 'Language'
  },
  footer: {
    copyright: 'Copyright',
    reserved: 'All Rights Reserved',
    companyIntro: 'Company Introduction',
    companyCulture: 'Company Culture',
    companyVision: 'Company Vision',
    businessPhilosophy: 'Business Philosophy',
    developmentHistory: 'Development History',
    qualifications: 'Qualifications & Honors',
    partners: 'Partners',
    serviceAreas: 'Service Areas',
    uavService: 'UAV Services',
    remoteSensing: 'Remote Sensing Data Services',
    modeling3d: '3D Digital Modeling Services',
    visualization3d: '3D Visualization Services',
    animation3d: '3D Animation Services',
    systemIntegration: 'System Integration Services',
    contactUs: 'Contact Us',
    handanCenter: 'Handan Production Center: 0310-5300963',
    handanAddress: 'Address: No. 5, Xunzi Street, Congtai District, Handan City, Hebei Province',
    wuanCenter: 'Wuan Technology Center: 19930806111',
    wuanAddress: 'Address: 6th Floor, Building 4, Phase IV of Entrepreneurship Service Center, Weisan Road, Industrial Park, Wuan City, Handan City, Hebei Province',
    officialWechat: 'Official WeChat Account',
    officialDouyin: 'Official Douyin Account',
    copyrightNotice: 'Copyright © 2022 Hebei Gaoxiang Geographic Information Technology Service Co., Ltd.'
  },
  home: {
    welcome: 'Welcome to our website',
    introduction: 'We are a professional geographic information service company'
  },
  productService: {
    title: 'Technical Services',
    titleEnglish: '',
    productTitle: 'Product Services',
    productTitleEnglish: '',
    services: ['UAV Services', 'Remote Sensing Data Services', '3D Digital Modeling Services', '3D Visualization Services', '3D Animation Services', 'System Integration'],
    productServices: ['Software Products', 'Hardware Products']
  },
  aboutUs: {
    title: 'About Us',
    titleEnglish: '',
    content: 'Hebei Gaoxiang Geographic Information Technology Service Co., Ltd. was founded in November 2015. It is a comprehensive high-tech enterprise deeply engaged in the field of geographic information, with both technical and product service capabilities. Focusing on geographic information, the company has built a full-chain technical service system of "data acquisition - processing and analysis - application development", providing services such as UAV application and training, aerial photogrammetry, real 3D modeling, and GIS system customization, offering one-stop solutions for natural resources, smart cities, agriculture, forestry, water conservancy, emergency management and other fields. At the same time, the company independently develops high-end intelligent equipment, mainly engaged in FPV drones, automated airports and UAV countermeasures equipment. The products are widely used in surveying and mapping, security inspection, emergency rescue, low-altitude protection and other scenarios, providing high-performance hardware support for various industries with stable performance and customized solutions.'
  },
  companyIntroduction: {
    title: 'Company Introduction',
    titleEnglish: 'Enterprise introduction',
    description: 'Hebei Gaoxiang Geographic Information Technology Service Co., Ltd. was founded in November 2015. It is a comprehensive high-tech enterprise deeply engaged in the field of geographic information, with both technical and product service capabilities. Focusing on geographic information, the company has built a full-chain technical service system of "data acquisition - processing and analysis - application development", providing services such as UAV application and training, aerial photogrammetry, real 3D modeling, and GIS system customization, offering one-stop solutions for natural resources, smart cities, agriculture, forestry, water conservancy, emergency management and other fields. At the same time, the company independently develops high-end intelligent equipment, mainly engaged in FPV drones, automated airports and UAV countermeasures equipment. The products are widely used in surveying and mapping, security inspection, emergency rescue, low-altitude protection and other scenarios, providing high-performance hardware support for various industries with stable performance and customized solutions.',
    companyCulture: {
      title: 'Corporate Culture',
      content: 'One family, one dream, always fighting, always winning'
    },
    businessPhilosophy: {
      title: 'Business Philosophy',
      content: 'Talents prosper the enterprise, technology strengthens the enterprise, quality establishes the enterprise, system manages the enterprise'
    },
    companyVision: {
      title: 'Corporate Vision',
      content: 'To become a leading surveying and mapping and geographic information service provider in the industry'
    },
    companySpirit: {
      title: 'Corporate Spirit',
      content: 'Symbiosis, co-construction, sharing',
      contentLeft: 'Gathering hearts, gathering strength, gathering wisdom, gathering energy'
    },
    qualifications: {
      title: 'Qualifications and Honors',
      titleEnglish: 'Qualifications and honors',
      statistics: [
        { title: 'Qualification Certificates', key: 'qualifications' },
        { title: 'Patents and Software Copyrights', key: 'patents' },
        { title: 'Project Awards', key: 'awards' },
        { title: 'Social Honors', key: 'honors' }
      ]
    },
    developmentHistory: {
      title: 'Development History',
      titleEnglish: 'Development history'
    },
    partners: {
      title: 'Partners',
      titleEnglish: 'Cooperation Partner'
    }
  },
  productServiceTab: {
    tabs: [
      { title: 'UAV Services', name: 'UAVService', iconClass: 'i-css iconfont icon-gx-airplane' },
      { title: 'Remote Sensing Data Services', name: 'RemoteSensingData', iconClass: 'i-css iconfont icon-gx-airdrop' },
      { title: '3D Digital Modeling Services', name: 'UAVTraining', iconClass: 'i-css iconfont icon-gx-buildings' },
      { title: '3D Visualization Services', name: 'Visualization', iconClass: 'i-css iconfont icon-gx-a-3d-cube-scan' },
      { title: '3D Animation Services', name: 'SurveyingServices', iconClass: 'i-css iconfont icon-gx-global-edit' },
      { title: 'System Integration Services', name: 'systemIntegration', iconClass: 'i-css iconfont icon-gx-format-square' }
    ],
    moduleTitle: 'Surveying Engineering'
  },
  surveyingServices: {
    title: '3D Animation Services',
    description: 'Relying on remote sensing, GIS, UAV aerial surveying and 3D modeling technologies, focusing on geospatial visualization and digital scene integration, we provide full-process solutions from data collection, model construction to animation production and scene rendering for urban construction, municipal administration, emergency response, environmental protection, transportation and other industries.',
    categories: [
      { title: '3D Display', items: ['Engineering Construction Simulation', 'City Roaming Display', 'Disaster Emergency Deduction'] }
    ]
  },
  uavService: {
    tabs: ['UAV Applications', 'UAV Training', 'UAV Performance'],
    applications: {
      categories: [
        { title: 'Aerial Surveying', items: ['Orthophoto', 'Panoramic Image', 'Tilted Model'] },
        { title: 'Intelligent Inspection', items: ['Natural Resources Inspection', 'Human Settlements Inspection', 'Power Inspection'] },
        { title: 'Agricultural Plant Protection', items: ['Agricultural Plant Protection'] },
        { title: 'Material Lifting', items: ['Material Lifting'] },
        { title: 'Emergency Rescue', items: ['Fire Rescue', 'Flood Rescue', 'Personnel Search and Rescue'] }
      ]
    },
    training: {
      categories: [
        { 
          title: 'Civil UAV Drivers License (CAAC) Training', 
          description: 'The Civil UAV Drivers License (CAAC) is issued by the Flight Standards Department of the Civil Aviation Administration of China, with high legal effect, and is a necessary certificate for employment in the UAV industry. Gaoxiang Geographic Jugao Vocational Training School has long carried out CAAC training, with a professional certified teaching team, helping students obtain certificates and work legally.'
        },
        { 
          title: 'Youth UAV Training', 
          description: 'Youth UAV training relies on professional teachers to create a step-by-step curriculum of "basic theory + simulation operation + practical application", stimulating young peoples scientific interest through characteristic classes and practical activities. Students who participate in UAV competitions and achieve good results can help with comprehensive quality evaluation, autonomous enrollment and strong foundation plan application, truly realizing "promoting learning through competition and empowering further education."'
        },
        { 
          title: 'UAV Skills Training', 
          description: 'The company has built a complete training system around core application fields such as UAV surveying and mapping, photography, lifting, inspection, and fire protection, helping students improve their UAV operation skills.'
        }
      ]
    },
    performance: {
      category: 'Technology Performance',
      items: ['Flying Carpet', 'Dragon and Phoenix', 'Bionic Wing Butterfly', 'Aeromodel Smoke']
    }
  },
  remoteSensingData: {
    title: 'Remote Sensing Data Services',
    description: 'The companys remote sensing image data covers the entire urban area of Handan, including rich information such as buildings, vegetation types, soil moisture, water quality parameters, surface temperature, seawater temperature, etc. The remote sensing images are regularly updated and covered, with historical data traceability function. In addition, the company can collect different information according to different needs of different customers, thereby providing customized services.',
    dataServices: {
      title: 'Data Services',
      items: ['Meter-level', 'Sub-meter level', 'Multispectral']
    },
    applicationScenarios: {
      title: 'Application Scenarios',
      items: ['Natural Resources Supervision', 'Urban Illegal Construction Supervision', 'Building Deformation Monitoring', 'Surface Subsidence Monitoring']
    }
  },
  threeDModeling: {
    title: '3D Digital Modeling Services',
    applicationScenarios: 'Application Scenarios',
    roadScene: {
      title: 'Road Scenes',
      description: 'Transforming real roads into 3D models through digital technology, which can be widely used in road design, traffic planning, traffic control and other fields.'
    },
    indoorScene: {
      title: 'Indoor Scenes',
      description: 'Carry out indoor scene 3D modeling based on SLAM or single-site cloud and photo data.'
    }
  },
  threeDVisualization: {
    title: '3D Visualization Services',
    description: 'Building reality-based 3D model effects, making data display more intuitive and easy to understand, and improving user interaction. 3D visualization has quickly become an important part of information digital management and is widely used in various industries.',
    relatedCases: 'Related Cases',
    cases: [
      {
        title: 'Comprehensive Pipe Gallery Visualization System Construction',
        description: 'The software uses a 3D stereo mode to simulate underground comprehensive pipe galleries, displaying, editing and storing 3D model data of pipe gallery main bodies, pipelines, equipment, etc. It integrates a system for monitoring data such as water, electricity, gas, heat, communication pipelines, harmful gas concentration, temperature and humidity, comprehensively perceiving key equipment and environmental information of the pipe gallery, interpreting urban energy information and security situation, and providing early warning for faults affecting the normal operation of the pipe gallery to ensure its normal operation; monitoring the dynamics of the pipe gallery body and pipe network, analyzing and collecting effective information, organizing historical data, assisting management personnel in making decisions, and improving operation and maintenance efficiency.'
      },
      {
        title: 'River and Lake Visualization',
        description: 'The smart big data comprehensive platform dynamically monitors rivers and lakes, timely collects, summarizes, analyzes and processes geospatial information, cross-industry information, etc., providing technical support for the refined management of rivers and lakes.',
        features: [
          'Using UAV patrols and video sensing to supervise passing ships, identify floating objects on the water, and timely alert for illegal sand mining, illegal sewage discharge, illegal occupation, illegal fishing, illegal swimming and other behaviors;',
          'Installing section sensors to timely detect illegal behaviors such as chemical enterprises and livestock breeding enterprise outlets, and real-time monitoring of water quality and water surface;',
          'Establishing water regime visualization telemetry stations, installing hydrological sensors and intelligent AI water gauge dome cameras, real-time detection of hydrological data, reading water gauge values, and early warning for urban floods.'
        ]
      },
      {
        title: '3D Digital Management Platform for Road Infrastructure',
        description: '3D digital management integrated solution for road infrastructure, including platform, equipment, software and data processing services, etc. The project addresses issues such as multiple types, large quantities, and wide coverage of road infrastructure at the road network level. Based on modern technical means, build a 3D digital platform for road infrastructure, unify various 3D data standards, and realize online management and visualization display services for massive infrastructure models; build a road asset digital management system and road inspection management system to realize precise management of road assets and efficient road inspection.'
      }
    ]
  },
  systemIntegration: {
    title: 'System Integration Services',
    description: 'Gaoxiang Geography takes meeting customer needs as the starting point, solves information processing and other problems for users through a combination of software, hardware and communication technology, comprehensively uses various information technology means to make all parts work organically and coordinately, thereby maximizing overall benefits and achieving the goal of overall optimization.',
    applicationAreas: 'Application Areas',
    systems: [
      {
        title: 'Bridge Safety Monitoring System',
        sections: [
          {
            title: '1. System Introduction',
            content: 'The bridge safety monitoring system integrates bridge structure monitoring, data visualization, danger alarm, real-time video monitoring and other functions. By installing various sensors and monitoring equipment on the bridge, it real-time collects data such as the structural status and environmental parameters of the bridge, and once an abnormality is found, it immediately sends an alarm to the data center.'
          },
          {
            title: '2. Hardware Integration',
            content: [
              'Monitoring and sensing hardware integration: Integrate high-precision displacement meters and high-definition video cameras to realize bridge visualization monitoring, meeting the dual needs of "data monitoring + visualization control."',
              'Terminal and alarm hardware integration: Integrate high-performance RTU terminals to realize data upload from sensing equipment. At the same time, supporting the integration of sound and light alarms, linked with monitoring data, when key indicators such as displacement exceed the early warning threshold, automatically trigger sound and light alarms.',
              'Power supply system hardware integration: Integrate solar components and energy storage equipment to provide clean, stable and sustainable power support for monitoring and sensing equipment and alarm equipment.'
            ]
          },
          {
            title: '3. Software Development',
            content: [
              'Platform independent research and development: Independently develop a bridge safety monitoring platform, access displacement and video monitoring data, and timely grasp the bridge safety status.',
              'Intelligent data analysis: Built-in intelligent analysis algorithms that can perform trend analysis and anomaly identification on displacement data. When data exceeds the early warning threshold, it automatically triggers platform early warning prompts and links sound and light alarms to start alarming.',
              'Software adaptation and integration: The software is compatible with various hardware devices, solving the connection problems between software and hardware, software and communication links, and realizing the full-process automated operation of "hardware collection - data transmission - software analysis - early warning prompts."'
            ]
          },
          {
            title: '4. Communication Guarantee',
            content: [
              'Communication link construction: Customize the construction of communication links, support 4G communication methods, and realize the docking of monitoring and sensing and alarm equipment with the monitoring platform.',
              'Data security guarantee: Adopt encrypted transmission technology to encrypt sensitive information to prevent data leakage. At the same time, optimize communication protocols to ensure data transmission efficiency.'
            ]
          }
        ]
      },
      {
        title: 'Intelligent Optical Fiber Sensing System',
        sections: [
          {
            title: '1. System Introduction',
            content: 'The intelligent optical fiber sensing system consists of a distributed optical fiber sensing vibration detection system and a distributed optical fiber sensing temperature monitoring system. It uses artificial intelligence pattern recognition algorithms to achieve real-time monitoring and identification of various disturbances (temperature, vibration, strain, etc.) applied to the optical fiber, achieving the purpose of early warning of threat behaviors in the first time.'
          },
          {
            title: '2. Hardware Integration',
            content: [
              'Detection optical cable: Including vibration optical cable and temperature sensing optical cable, which can adopt various laying methods such as surface, embedded, and buried according to the scene.',
              'Distributed optical fiber linear vibration monitoring host: Real-time sensing, positioning and monitoring of vibration, disturbance and intrusion events along the optical cable.',
              'Distributed optical fiber linear temperature sensing detection host: Real-time monitoring of temperature changes along the optical cable and precise positioning of abnormal hot spots.'
            ]
          },
          {
            title: '3. Software Development',
            content: [
              'Distributed centralized monitoring: Adopting a distributed architecture design method, it is more suitable for the application of monitoring systems with scattered characteristics in space.',
              'Rich interaction methods: Build a monitoring system platform based on configuration, support client monitoring and Web browsing methods, can interact with GIS data, and support 3D display.',
              'Efficient linkage mechanism: Adopt a three-level linkage mechanism to greatly improve the automation level of the monitoring system; combined with the systems powerful and comprehensive integration capabilities, make the linkage efficiency more flexible and efficient.',
              'Comprehensive integration support: Based on weakly coupled open modular interface design, it can realize integration support with hardware equipment from different professional systems.'
            ]
          },
          {
            title: '4. Communication Guarantee',
            content: [
              'Field equipment communication lines: Use dedicated cables to achieve short-distance communication between field equipment, respectively transmitting video data, alarm switch signals, and equipment interaction network data.',
              'System networking and communication: Build a field local area network through network switches to realize network interconnection of field hardware equipment. The monitoring center relies on standard communication interfaces such as Ethernet to realize the docking of the software platform with back-end processing equipment.'
            ]
          }
        ]
      }
    ]
  },
  hvSeries: {
    bannerTitle1: 'TK50',
    bannerTitle2: 'Agricultural UAV',
    bannerSlogan: 'Technology Leads, Empowering Green Revolution',
    modelIntro: 'TK50 four-axis agricultural drone with 50L load. The upgraded intelligent control system ensures smoother and lighter operation.<br>The high-flow impeller pump and water-cooled centrifugal nozzle<br>allow quick and easy switching between spraying and spreading systems.',
    powerTitle: 'TK50 X13 Power System',
    powerSubtitle: 'High thrust, efficient, fast response',
    sprayTitle: 'Spraying System',
    sprayDesc: 'Features an all-new dual centrifugal nozzle with high flow rate, fine atomization, and strong penetration. Effectively penetrates dense crop canopies for uniform coverage on both leaf surfaces.',
    spreadingTitle: 'Spreading System',
    spreadingDesc: '80L extra-large capacity spreader box, 360° high-flow spreading, newly upgraded serrated mixing plate',
    bodyTitle: 'Robust Body, Solid & Stable',
    bodyDesc: 'Smart manufacturing unlocks infinite possibilities, balancing practicality, durability, and cost-effectiveness for easy daily transport and assembly',
    highlightsTitle: 'Highlight Showcase',
    batteryTitle: 'Intelligent Battery',
    batterySpec: '18s 30000mah',
    powerCard1Title: 'High Load Motor',
    powerCard1Desc: 'Performance enhanced, thrust increased',
    powerCard2Title: 'High-Strength Propeller',
    powerCard2Desc: '55-inch large propeller',
    powerCard3Title: 'High-Power ESC',
    powerCard3Desc: 'More precise control',
    spreadImg1: 'Fertilizer Spreading',
    spreadImg2: 'Seed Spreading',
    spreadImg3: 'Bait Spreading',
    radar1: 'Terrain-Following Radar',
    radar2: 'Obstacle-Avoidance Radar',
    radar3: 'HD Camera',
    inventoryPowerTitle: 'Power List',
    inventoryFrameTitle: 'Frame List',
    propCW: 'Propeller CW',
    motorCW: 'Motor CW',
    propHolder: 'Prop Holder',
    propCCW: 'Propeller CCW',
    motorCCW: 'Motor CCW',
    fuselageAssembly: 'Fuselage Assembly',
    landingGear: 'Landing Gear',
    wireRubber: 'Arm Wire Rubber',
    waterTank: 'Water Tank',
    carbonArm: 'Carbon Fiber Arm',
    adapterPlate: 'Adapter Carbon Plate',
    gearPad: 'Gear Pad',
    partsBag: 'Parts Bag',
    crossTube: 'Cross Tube',
    teeJoint: 'Tee Joint',
    waterPipe: 'Water Pipe',
    accessory1Title: 'Dual-Port Large Tank',
    accessory1Desc: 'Dual opening design for faster and more convenient refilling',
    accessory2Title: 'Centrifugal Nozzle',
    accessory2Desc: 'Ultimate atomization and even coverage, using high-speed rotational centrifugal force to "spray" liquid into micron-sized uniform droplets, easily penetrating crop canopies',
    accessory3Title: 'High-Flow Impeller Pump',
    accessory3Desc: 'Efficient (high flow), lightweight, stable spraying, reliable and durable, low maintenance for field and orchard operations',
    accessory4Title: 'Weight Sensor',
    accessory4Desc: 'Equipped with three load sensors to provide real-time feedback on tank status for peace of mind',
    pumpPressure: 'Max Pump Pressure',
    pumpValue: '0.8MPa',
    nozzle: 'Nozzle',
    nozzleValue: 'Centrifugal Nozzle',
    sprayFlow: 'Spray Flow Rate',
    sprayFlowValue: '12L/min',
    sprayWidth: 'Spray Width',
    sprayWidthValue: '6-10m',
    tankLoad: 'Tank Capacity',
    tankLoadValue: '50L',
    workHours: 'Effective Coverage',
    workHoursValue: '70 Mu',
    flyControlModule: 'Integrated Flight Control Module',
    flyControlModuleDesc: 'High integration, quick installation, waterproof and dustproof for a convenient and efficient user experience',
    armSensor: 'Arm Sensor',
    armSensorDesc: 'Adopts press-lock mode with dual insurance to prevent arm loosening during flight',
    copperBoard: 'Thick Copper PCB',
    copperBoardDesc: 'High current capacity, special waterproof adhesive, durable and reliable, adapted to various environments for long-term stability',
    trussStructure: 'Truss Structure',
    trussStructureDesc: 'High strength, lightweight, low resonance, sturdy and reliable, resistant to deformation and fracture'
  },
  contactUs: {
    title: 'Contact Us',
    titleEnglish: 'Contact us',
    handanCenter: 'Handan Production Center',
    handanPhone: 'Phone: 0310-5300963',
    handanAddress: 'Address: No. 5, Xunzi Street, Congtai District, Handan City, Hebei Province',
    wuanCenter: 'Wuan Technology Center',
    wuanPhone: 'Phone: 19930806111',
    wuanAddress: '6th Floor, Building 4, Phase IV of Entrepreneurship Service Center, Weisan Road, Industrial Park, Wuan City, Handan City, Hebei Province',
    branchAddresses: 'Branch Addresses',
    branchCities: ['Shijiazhuang', 'Xingtai', 'Linzhang', 'Qiuxian', 'Guangping', 'Quzhou'],
    branchNames: ['Shijiazhuang Branch', 'Xingtai Branch', 'Linzhang Branch', 'Qiuxian Branch', 'Guangping Branch', 'Quzhou Branch'],
    branchPhones: ['0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963'],
    branchAddress: 'No. 108, Guangming South Street, Hanshan District, Handan City, Hebei Province'
  },
  productDisplay: {
    softwareProducts: 'Software Products',
    hardwareProducts: 'Hardware Products',
    vmap: {
      name: 'Vmap (Hebei)',
      tagline: 'Basic Digital Foundation for Twin Cities',
      features: {
        dataAsset: { title: 'Data Asset Aggregation', desc: 'Aggregating vector and image data resources' },
        historyImage: { title: 'Historical Image Trace', desc: 'Supporting 2018-2025 annual image integration' },
        customizedRelease: { title: 'Customized Data Release', desc: 'Supporting regional data customized release' },
        vectorTools: { title: 'Vector Production Tools', desc: 'Providing professional vector mapping tools' },
        openApi: { title: 'Open API Capability', desc: 'Open POI interface, supporting secondary development' }
      }
    },
    uavControl: {
      name: 'UAV Control Platform',
      tagline: 'Intelligent Management and Control Platform for UAV Inspection',
      features: {
        deviceManagement: { title: 'Intelligent Device Management', desc: 'Real-time monitoring parameters, generating health reports' },
        routePlanning: { title: 'Intelligent Route Planning', desc: 'Human + algorithm, simulating and optimizing flight plans' },
        flightMonitoring: { title: 'Real-time Flight Monitoring', desc: 'Multi-dimensional early warning and emergency handling' },
        obstacleAvoidance: { title: 'Intelligent Tagging and Obstacle Avoidance', desc: 'Automatically identifying obstacles and executing avoidance' },
        resultManagement: { title: 'Result Management and Sharing', desc: 'Centralized storage, keyword search, online analysis' }
      }
    },
    spatioTemporalData: {
      name: 'Spatiotemporal Data Asset Management Platform',
      tagline: 'Intelligent Management and Analysis Platform for Data Assets',
      features: {
        dataIntegration: { title: 'Data Integration and Analysis', desc: 'Breaking data silos, achieving seamless connection' },
        massDataManagement: { title: 'Mass Data Management', desc: 'Efficiently managing 3D models, laser point clouds and other data' },
        standardizedSharing: { title: 'Standardized Data Sharing', desc: 'Unified format interface, link + password secure access' },
        autoProcessing: { title: 'Automated Data Processing', desc: 'Image stitching, composition, 3D reconstruction automation' }
      }
    },
    hardware: {
      portableJammer: {
        name: 'Portable Jamming Gun',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        collapseParams: 'Collapse Parameters',
        expandParams: 'Core Parameters',
        intro: 'The portable jamming gun can remotely block remote control signals, forcing UAVs to land or return, ensuring low-altitude safety, depriving the remote controller of view and positioning capabilities, achieving precise control.',
        params: {
          powerSupply: 'Stable work for 3 days on one charge, external charger',
          interceptionMode: 'Forced dispersal, forced landing, image transmission interference',
          interceptionChannel: 'Four channels',
          controlDistance: '≥1500m (open area without electromagnetic interference)',
          supportedBands: '1560-1620MHz / 2400-2500MHz / 5725-5850MHz / 900-930MHz'
        },
        labels: {
          powerSupply: 'Power Supply',
          interceptionMode: 'Interception Mode',
          interceptionChannel: 'Interception Channel',
          controlDistance: 'Control Distance',
          supportedBands: 'Supported Bands'
        }
      },
      photoelectricTracking: {
        name: 'Photoelectric Tracking Equipment',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        collapseParams: 'Collapse Parameters',
        expandParams: 'Core Parameters',
        intro: 'Photoelectric tracking equipment uses radio or radar guidance to capture and process optical or infrared images of UAVs, with continuous day and night tracking, excellent low-altitude tracking performance, high precision, and real-time recording of target video and image information.',
        params: {
          rotationRange: 'Azimuth 0°~360°, Pitch -45°~90°',
          trackingDistance: 'Day 3km / Night 2km',
          positioningAccuracy: '±0.2°',
          workingTemp: '-40℃ ~ +70℃'
        },
        labels: {
          rotationRange: 'Rotation Range',
          trackingDistance: 'Tracking Distance',
          positioningAccuracy: 'Positioning Accuracy',
          workingTemp: 'Working Temperature'
        }
      },
      radarDetection: {
        name: 'Radar Detection Equipment',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        collapseParams: 'Collapse Parameters',
        expandParams: 'Core Parameters',
        intro: 'Radar detection equipment includes radar array, mechanical turntable and power supply components, specifically used for small UAV monitoring at borders, airports and other locations, accurately obtaining target position, distance, altitude and moving speed information.',
        params: {
          workingBand: 'X-band',
          detectionDistance: 'UAV 5km / Pedestrian 8km / Vehicle 10km',
          azimuthCoverage: '360°',
          workingTemp: '-40℃ ~ +55℃'
        },
        labels: {
          workingBand: 'Working Band',
          detectionDistance: 'Detection Distance',
          azimuthCoverage: 'Azimuth Coverage',
          workingTemp: 'Working Temperature'
        }
      },
      fullBandDevice: {
        name: 'Full-Band Detection-Jamming-Deception Equipment',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        collapseParams: 'Collapse Parameters',
        expandParams: 'Core Parameters',
        intro: 'Full-band detection-jamming-deception equipment integrates electronic scanning and interference functions, covering antenna arrays, power amplifiers and signal processors, achieving autonomous detection, interference and deception of low-speed UAVs.',
        params: {
          wirelessDetectionDistance: '≥6km',
          linkJammingDistance: '5km (dry-connection ratio >10:1)',
          droneIdentificationTypes: '≥200 types',
          timeAccuracy: '<30ns'
        },
        labels: {
          wirelessDetectionDistance: 'Wireless Detection Distance',
          linkJammingDistance: 'Link Jamming Distance',
          droneIdentificationTypes: 'Drone Identification Types',
          timeAccuracy: 'Time Accuracy'
        }
      },
      fixedDevice: {
        name: 'Fixed Detection-Jamming Equipment',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        collapseParams: 'Collapse Parameters',
        expandParams: 'Core Parameters',
        intro: 'Fixed detection-jamming equipment has the ability to remotely cut off control signals, forcing target UAVs to execute landing or return commands. It can also deprive the remote controller of UAV view access and positioning control rights, achieving precise UAV control.',
        params: {
          detectionDistance: '1.5-4KM (depending on antenna)',
          detectionTime: '≤2 seconds (varies with UAV distance)',
          jammingBands: '900MHz, GPS, 2.4GHz, 5.8GHz',
          jammingDistance: '≥1.5km',
          protectionLevel: '≥IP66'
        },
        labels: {
          detectionDistance: 'Detection Distance',
          detectionTime: 'Detection Time',
          jammingBands: 'Jamming Bands',
          jammingDistance: 'Jamming Distance',
          protectionLevel: 'Protection Level'
        }
      },
       TK50: {
        name: 'TK50',
        equipmentIntro: 'Equipment Introduction',
        coreParams: 'Core Parameters',
        collapse: 'Collapse',
        expand: 'Equipment Introduction',
        expandParams: 'Core Parameters',
        intro: 'TK50 is a lightweight equipment that can be operated by a single person, and it can provide efficient solutions for multiple production processes of different crops. The daily work efficiency of TK50 is up to 70 hectares.',
      }

    }
  }
}